import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { buildOrgTree } from "../domains/buildOrgTree";
import { flattenVisibleTree } from "../domains/flattenVisibleTree";
import OrgTreeRowReadOnly from "./OrgTreeRowReadOnly";
import { isMonthlyMode } from "../domains/targetSetup";

const OrgBreakdownPanel = observer(
  ({ orgs, monthOptions = [], targetFrequency, collapsed, onToggle }) => {
    const { t } = useTran();
    const isMonthly = isMonthlyMode(targetFrequency);
    const tree = useMemo(() => buildOrgTree(orgs), [orgs]);
    const flatRows = useMemo(
      () => flattenVisibleTree(tree, collapsed),
      [tree, collapsed],
    );

    return (
      <>
        <div className="flex items-center border-b px-3 py-2">
          <span className="flex-1 text-xs font-medium text-muted-foreground">
            {t("Organization")}
          </span>
          {isMonthly ? (
            <span className="flex-[2] text-left text-xs font-medium text-muted-foreground">
              {t("Monthly Targets")}
            </span>
          ) : (
            <>
              <span className="w-40 text-center text-xs font-medium text-muted-foreground">
                {t("Target Value")}
              </span>
              <span className="w-40 text-center text-xs font-medium text-muted-foreground">
                {t("Unit")}
              </span>
            </>
          )}
        </div>
        {flatRows.map((row) => (
          <OrgTreeRowReadOnly
            key={row.collapseKey}
            node={row.node}
            monthOptions={monthOptions}
            targetFrequency={targetFrequency}
            depth={row.depth}
            hasChildren={row.hasChildren}
            collapseKey={row.collapseKey}
            isCollapsed={collapsed.has(row.collapseKey)}
            onToggleCollapse={onToggle}
          />
        ))}
      </>
    );
  },
);

export default OrgBreakdownPanel;
